// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"8d0a453a","416":"8d0a453a","629":"8d0a453a","911":"8d0a453a"}[chunkId] + ".chunk.css";
};